import { useState, useEffect } from "react";
import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import MDInput from "ui/MDInput";
import MDButton from "ui/MDButton";
import MDAlert from "ui/MDAlert";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Header from "layouts/user-profile/Header";
import AuthService from "../../services/auth-service";

const UserProfile = () => {
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(false);
  const [user, setUser] = useState(null);

  const [errors, setErrors] = useState({
    name: false,
    lastNameError: false,
    emailError: false,
    newPassError: false,
    confirmPassError: false,
  });

  const getUserData = async () => {
    try {
      const response = await AuthService.getProfile();
      console.log("Profile API response:", response);

      if (response && response.user) {
        setUser({
          ...response.user,
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
      } else {
        console.error("User data not found in response:", response);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };


  useEffect(() => {
    getUserData();
  }, []);

  useEffect(() => {
    if (notification) {
      setTimeout(() => {
        setNotification(false);
      }, 3000);
    }
  }, [notification]);

  const changeHandler = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    // validation
    const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    let hasError = false;

    // Validate first name
    if (user.name.trim().length === 0) {
      setErrors((prevState) => ({ ...prevState, name: true }));
      hasError = true;
    }

    // Validate email
    if (user.email.trim().length === 0 || !user.email.trim().match(mailFormat)) {
      setErrors((prevState) => ({ ...prevState, emailError: true }));
      hasError = true;
    }

    // Validate password
    if (user.newPassword?.trim().length || user.confirmPassword?.trim().length) {
      if (user.newPassword.trim() !== user.confirmPassword.trim()) {
        setErrors((prevState) => ({ ...prevState, confirmPassError: true }));
        hasError = true;
      }
      if (user.newPassword.trim().length < 8) {
        setErrors((prevState) => ({ ...prevState, newPassError: true }));
        hasError = true;
      }
    }
    console.log('user is', user, hasError);

    if (hasError) {
      return;
    }

    let userData = {
      name: user.name,
      email: user.email,
    };

    if (user.newPassword?.length > 0) {
      userData.password = user.newPassword;
      userData.password_confirmation = user.confirmPassword;
    }
    setLoading(true);
    const response = await AuthService.updateProfile(userData);

    setErrors({
      name: false,
      emailError: false,
      newPassError: false,
      confirmPassError: false,
    });

    setLoading(false);
    if (response.success) {
      localStorage.setItem('user', JSON.stringify(response.data));
      setNotification({
        type: 'success',
        message: response.message,
      });
      setUser(response.data);
    } else {
      setNotification({
        type: 'error',
        message: response.errors[0],
      });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      {user && (
        <Header user={user} submitHandler={submitHandler}>
          <MDBox
            component="form"
            role="form"
            onSubmit={submitHandler}
            display="flex"
            flexDirection="column"
            py={0}
            px={3}
          >
            {notification && (
              <MDAlert color="success" mt="20px">
                <MDTypography variant="body2" color="white">
                  Your profile has been updated
                </MDTypography>
              </MDAlert>
            )}

            <MDBox display="flex" flexDirection="row" mt={5} mb={3}>
              <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  Name
                </MDTypography>
                <MDBox mb={2} width="100%">
                  <MDInput
                    type="text"
                    fullWidth
                    name="name"
                    value={user.name}
                    onChange={changeHandler}
                    error={errors.name}
                  />
                  {errors.name && (
                    <MDTypography variant="caption" color="error" fontWeight="light">
                      Name cannot be empty
                    </MDTypography>
                  )}
                </MDBox>
              </MDBox>
              <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  Email
                </MDTypography>
                <MDBox mb={2} width="100%">
                  <MDInput
                    type="email"
                    fullWidth
                    name="email"
                    value={user.email}
                    onChange={changeHandler}
                    error={errors.emailError}
                  />
                  {errors.emailError && (
                    <MDTypography variant="caption" color="error" fontWeight="light">
                      Please enter a valid email address
                    </MDTypography>
                  )}
                </MDBox>
              </MDBox>
            </MDBox>


            <MDBox display="flex" flexDirection="row" mb={3}>
              <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  New Password
                </MDTypography>
                <MDBox mb={2} width="100%">
                  <MDInput
                    type="password"
                    fullWidth
                    name="newPassword"
                    placeholder="New Password"
                    value={user.newPassword || ""}
                    onChange={changeHandler}
                    error={errors.newPassError}
                    inputProps={{
                      autoComplete: "new-password",
                      form: {
                        autoComplete: "off",
                      },
                    }}
                  />
                  {errors.newPassError && (
                    <MDTypography variant="caption" color="error" fontWeight="light">
                      Password must be at least 8 characters long
                    </MDTypography>
                  )}
                </MDBox>
              </MDBox>
              <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                  Confirm Password
                </MDTypography>
                <MDBox mb={2} width="100%">
                  <MDInput
                    type="password"
                    fullWidth
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    value={user.confirmPassword || ""}
                    onChange={changeHandler}
                    error={errors.confirmPassError}
                    inputProps={{
                      autoComplete: "off",
                      form: {
                        autoComplete: "off",
                      },
                    }}
                  />
                  {errors.confirmPassError && (
                    <MDTypography variant="caption" color="error" fontWeight="light">
                      Password confirmation does not match
                    </MDTypography>
                  )}
                </MDBox>

              </MDBox>
            </MDBox>
          </MDBox>
        </Header>
      )
      }
      <Footer />
    </DashboardLayout >
  );
};

export default UserProfile;
